<div class="carousel-container" [style.--db-primary-color]="dbCard?.primaryColor" [style.--text-color-dynamic]="dbCard?.digitalCardTextColor">
  <span style="font-weight: 600; font-size: 16px; color: var(--text-color);">
    Products
  </span>
  <!-- Carousel Track -->
  <div class="carousel-wrapper mt-3" *ngIf="productCarousel.length > 0; else noProducts">
    <button *ngIf="productCarousel.length > 1" id="prevSlide" class="nav-button prev" (click)="prevSlide()">‹</button>

    <div class="carousel-track" #carouselTrack>
      <div class="carousel-slide" *ngFor="let product of productCarousel; let i = index">
        <div class="product-card" [id]="'productCard' + i">

          <!-- Image -->
          <div class="image-container" [id]="'imageContainer' + i">
            <img
              [src]="product?.imageUrl || 'assets/images/products/no-product.png'"
              [alt]="product?.name"
              class="product-image"
            />
          </div>

          <!-- Details -->
          <div class="product-details" [id]="'productDetails' + i">
            <div class="price" *ngIf="product?.price">{{ product?.price | currency:'USD':'symbol':'1.2-2' }}</div>
            <div class="name" *ngIf="product?.name">{{ product?.name }}</div>
            <div class="description" *ngIf="product?.description">{{ product?.description }}</div>
            <button
              *ngIf="product?.url || product?.imageUrl"
              pButton
              type="button"
              label="View"
              class="p-button-rounded p-fluid"
              [id]="'showBtn' + i"
              (click)="onShowClick(product.url || product.imageUrl)"
            ></button>
          </div>

        </div>
      </div>
    </div>

    <button *ngIf="productCarousel.length > 1" id="nextSlide" class="nav-button next" (click)="nextSlide()">›</button>
  </div>

  <!-- Fallback -->
  <ng-template #noProducts>
    <div class="text-center p-text-secondary mt-5">No products available.</div>
  </ng-template>
</div>


